export const PAGE_IDS = {
  MAIN: "main",
  EXECUTIVE_DASHBOARD: "executive-dashboard",
  THREAT_MAP: "threat-map",
  POSTURE_MANAGEMENT: "posture-management",
  NIRA_CHAT: "nira",
  CLIENT_HUB: "client-hub",
  CLIENT_HUB_OVERVIEW: "client-hub/overview",
  CLIENT_HUB_PRODUCT_MATURITY: "client-hub/product-maturity",
  CLIENT_HUB_ROI_INSIGHTS: "client-hub/roi-insights",
  CLIENT_HUB_QBR_PLANNING: "client-hub/qbr-planning",
  GOVERNANCE_AI_INVENTORY: "governance/ai-inventory",
  GOVERNANCE_AI_ADOPTION: "governance/ai-adoption",
  GOVERNANCE_DATA_RISKS: "governance/data-risks",
  GOVERNANCE_TPRM: "governance/tprm",
  PROFILE: "profile",
  HELP: "help",
} as const;

export type PageId = (typeof PAGE_IDS)[keyof typeof PAGE_IDS];

/** Display metadata for the settings UI */
export const PAGE_METADATA: Record<PageId, { label: string; group: string; route: string }> = {
  main: { label: "Home", group: "Core", route: "/main" },
  "executive-dashboard": { label: "Summary", group: "Core", route: "/executive-dashboard" },
  "threat-map": { label: "Incidents", group: "Security", route: "/threat-map" },
  "posture-management": { label: "Security Posture", group: "Security", route: "/posture-management" },
  nira: { label: "Nira Chat", group: "AI", route: "/nira" },
  "client-hub": { label: "Client Hub", group: "Client", route: "/client-hub" },
  "client-hub/overview": { label: "Business Review", group: "Client", route: "/client-hub/overview" },
  "client-hub/product-maturity": { label: "Product Maturity", group: "Client", route: "/client-hub/product-maturity" },
  "client-hub/roi-insights": { label: "ROI Insights", group: "Client", route: "/client-hub/roi-insights" },
  "client-hub/qbr-planning": { label: "Reports", group: "Client", route: "/client-hub/qbr-planning" },
  "governance/ai-adoption": { label: "AI Adoption", group: "Governance", route: "/governance/ai-adoption" },
  "governance/data-risks": { label: "Data Risks", group: "Governance", route: "/governance/data-risks" },
  "governance/ai-inventory": { label: "Gen AI Risk", group: "Governance", route: "/governance/ai-inventory" },
  "governance/tprm": { label: "Third Party Risk", group: "Governance", route: "/governance/tprm" },
  profile: { label: "Settings", group: "System", route: "/profile" },
  help: { label: "Help", group: "System", route: "/help" },
};

/** Map a pathname to the pageId used for route-level access control. */
export const resolvePageId = (pathname: string): PageId | null => {
  const normalized = pathname.replace(/\/$/, "") || "/";

  // Exact match against PAGE_METADATA routes
  for (const [pageId, meta] of Object.entries(PAGE_METADATA)) {
    if (meta.route === normalized) return pageId as PageId;
  }

  // Parameterized routes: /profile/*, /client-hub/*, /posture-management/*
  // These render under a parent pageId, so the sub-route must resolve to it —
  // otherwise the AppShell access guard sees no pageId and lets the page render.
  if (normalized.startsWith("/profile")) return "profile" as PageId;
  if (normalized.startsWith("/client-hub/")) return "client-hub" as PageId;
  if (normalized.startsWith("/posture-management/")) return "posture-management" as PageId;

  return null;
};
